import './WatchWristDiscoverTool.less';
import React, {useState, useEffect} from 'react';
import WatchWristViewer from "../../widgets/watch-wrist-viewer/WatchWristViewer";
import WristSelector from "../../widgets/wrist-selector/WristSelector";
import AspectContainer from '../../../components/aspect-container/AspectContainer';
import ProductToolControlBlock from '../../widgets/product-tool-control-block/ProductToolControlBlock';
import __ from '../../../i18n';
import ProductToolMessageBox from '../../widgets/product-tool-message-box/ProductToolMessageBox';
import {TYPE_WATCH} from '../../../model-constants/product-class/types';
import Request from '../../../api/Request';
import ProductAttributeByProductParcel from '../../endpoints/product-attribute/ProductAttributeByProductParcel';
import WatchAttributesViewer from '../../widgets/watch-attributes-viewer/WatchAttributesViewer';
import ProductExtraOrderBlock from '../../widgets/product-extra-order-block/ProductExtraOrderBlock';
import ZoomController from "../../widgets/zoom-controller/ZoomController";
import ProductExtraBadge from "../../widgets/product-extra-badge/ProductExtraBadge";
import ProductWatchPrototypeListParcel from "../../endpoints/product-watch-prototype/ProductWatchPrototypeListParcel";


export default function WatchWristDiscoverTool({
    wristPrototypes,
    images,
    productAttributes,
    productAttributeGroups,
    wristSizeMeasurementUrl,
    onChangeProductWatchPrototype = () => {},
    cartHandler,
}) {

    const [storedImages, setStoredImages] = useState(images);

    const [selectedWristPrototype, setSelectedWristPrototype] = useState(null);

    const [selectedProductWatchPrototype, setSelectedProductWatchPrototype] = useState(null);

    const [message, setMessage] = useState(null);

    const [attributeIds, setAttributeIds] = useState(null);

    const requestAttributeIds = (productId) => {
        Request.add(new ProductAttributeByProductParcel(productId))
            .then(data => {
                setAttributeIds(data.junctions.map(t => t.product_attribute_id));
            }).catch(error => {
            setAttributeIds(null);
        });
    };

    const onProductPrototypeChange = (productPrototype, prototypeImages) => {
        const newImages = prototypeImages.filter(t => !storedImages.map(m => m.id).includes(t.id));
        if (newImages.length > 0) {
            setStoredImages(storedImages.concat(newImages));
        }
        setSelectedProductWatchPrototype(productPrototype);
    };

    useEffect(() => {
        onChangeProductWatchPrototype(selectedProductWatchPrototype, storedImages);

        if (selectedProductWatchPrototype === null) {
            return;
        }

        requestAttributeIds(
            selectedProductWatchPrototype.product_id,
        );
    }, [selectedProductWatchPrototype && selectedProductWatchPrototype.id]);

    const genderedWristPrototypes = selectedProductWatchPrototype === null ? null :
        wristPrototypes.filter(t => t.gender === selectedProductWatchPrototype.appropriate_gender);

    const attributes = attributeIds === null ? null :
        productAttributes.filter(t => attributeIds.includes(t.id));

    const attributeGroups = attributes === null ? null :
        productAttributeGroups.filter(t => attributes.some(a => a.group_id === t.id));

    const [zoomScale, setZoomScale] = useState(1.05);

    const [isNotEnoughData, setIsNotEnoughData] = useState(false);

    if (isNotEnoughData) {
        return <div className="watch-wrist-discover-tool">
            <div className="message-area">
                <ProductToolMessageBox message={__('There is not enough data to display')}/>
            </div>
        </div>;
    }

    return <div className="watch-wrist-discover-tool">
        <div className="viewer-wrapper">
            <AspectContainer ratio={4/3}>
                {
                    message &&
                    <div className="message-area">
                        <ProductToolMessageBox message={message}/>
                    </div>
                }
                {
                    selectedProductWatchPrototype &&
                    selectedWristPrototype &&
                    <>
                        <WatchWristViewer
                            watchPrototype={selectedProductWatchPrototype}
                            wristPrototype={selectedWristPrototype}
                            images={storedImages}
                            zoomScale={zoomScale}
                        />
                        <ZoomController
                            defaultValue={zoomScale}
                            onChange={setZoomScale}
                            max={1.6}
                        />
                    </>
                }
            </AspectContainer>
        </div>
        <div className="control-panel">
            <ProductExtraBadge
                initialExtraId={null}
                productClassType={TYPE_WATCH}
                ProductExtraListParcel={ProductWatchPrototypeListParcel}
                browseButtonText={__('Select another watch')}
                browseToolTitle={__('Select your watch')}
                onChange={onProductPrototypeChange}
                onLoadedEmpty={() => {
                    setSelectedProductWatchPrototype(null);
                    setIsNotEnoughData(true);
                }}
            />
            {
                genderedWristPrototypes &&
                genderedWristPrototypes.length > 0 &&
                <ProductToolControlBlock
                    title={__('Select your wrist size')}
                    extra={
                        !wristSizeMeasurementUrl ? undefined :
                            <a href={wristSizeMeasurementUrl} target="_blank" title={__('Open in new tab')}>
                                {__('Wrist size measurement guidelines')}
                            </a>
                    }
                >
                    <WristSelector
                        wristPrototypes={genderedWristPrototypes}
                        defaultWristPerimeter={selectedWristPrototype ? selectedWristPrototype.wrist_perimeter : null}
                        onSelectedWristPrototypeIdChange={(selectedId) => {
                            setSelectedWristPrototype(genderedWristPrototypes.find(t => t.id === selectedId));
                        }}
                    />
                </ProductToolControlBlock>
            }
            {
                attributes !== null &&
                attributeGroups !== null &&
                <ProductToolControlBlock
                    title={__('Watch specifications')}
                    heightLimited={false}
                >
                    <WatchAttributesViewer
                        attributes={attributes}
                        groups={attributeGroups}
                    />
                </ProductToolControlBlock>
            }
            {
                selectedProductWatchPrototype &&
                <ProductExtraOrderBlock
                    buttonText={__('Add watch to cart')}
                    productExtra={selectedProductWatchPrototype}
                    images={storedImages}
                    cartHandler={cartHandler}
                />
            }
        </div>
    </div>;
}
